import Header from './components/Header';
import Hero from './components/Hero';
import FAQSection from './components/FAQSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import AppSection from './components/AppSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <FAQSection />
        <IndexSection />
        <UpdatesSection />
        <AboutSection />
        <CardsSection />
        <CarouselSection />
        <CommentsSection />
        <FeaturesSection />
        <AppSection />
        <ContactSection />
        <TopicsSection />
        <MediaSection />
        <RankingSection />
      </main>
      <Footer />
    </>
  );
}